export default function () {
  return [{
    label: '编号',
    type: 'Input',
    name: 'itemNumber',
  },
  {
    label: '子系统',
    type: 'Select',
    name: 'systemCode',
    optionList: [
      {
        value: 'dangjian',
        label: '党建'
      },
      {
        value: 'gongjian',
        label: '工会'
      },
      {
        value: 'tuanjian',
        label: '青团'
      },
      {
        value: 'qixuan',
        label: '文化'
      },
      {
        value: 'qihua',
        label: 'CCO'
      }
    ]
  },
  {
    label: '待办名称',
    type: 'Input',
    name: 'itemName'
  },
  {
    label: '待办分组',
    type: 'Input',
    name: 'todoGroup'
  },
  {
    label: '交办时间',
    type: 'DatePicker',
    name: 'assignedDate',
    props: {
      format: 'yyyy-MM-dd'
    },
    format: 'daterange',
    config: {
      searchKeyMap: ['assignDateStart', 'assignDateEnd']
    }
  }
  ]
}